import { FC } from 'react';
import { img_mindd } from '.';

const MinddImage: FC<{ width?: number }> = ({ width = 115 }) => {
  return <img src={img_mindd} width={width} alt="" />;
};

export default MinddImage;
